import './custom_selectize';

export default function stateWatcher(state_input, city_input) {
  $(state_input).on('change', (el) => {
    const stateId = $(el.currentTarget).val();
    const $select = $(city_input);
    const { selectize } = $select[0];
    selectize.clear();
    selectize.clearOptions();
    if (stateId !== '') {
      $.get(`/states/${stateId}/cities`, (cities) => {
        selectize.addOption(cities);
        selectize.refreshOptions();
      });
    }
  });
}
